import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { useHistory } from 'react-router-dom';
import { useNavMenu } from '../../../providers/NavMenu.provider';

type ELinxCreationProps = {
  eLinx: vp.SendELinxResponse;
};
type FC = FunctionComponent<ELinxCreationProps>;

const PaylinkCreationPage: FC = (props: ELinxCreationProps) => {
  const { eLinx } = props;
  const { Box, SubTitle, Title, Button, TextField } = vp;
  const history = useHistory();
  const { setSubNavActiveModule } = useNavMenu();

  return (
    <Box flx="col">
      <Box mb="md" jc="sb">
        <Title title="Send eLinx Connect Request" />
      </Box>
      <Box mt="lg">
        <SubTitle subTitle="eLinx Connect Request successfully sent!" />
      </Box>
      <Box mt="lg">
        An email with your connection request will be sent to contact {eLinx.ReceiverName} to connect their bank
        account. The link is also available below in case you need it. Once the request is complete you can start
        processing EFT transactions with this account.
      </Box>
      <Box mt="lg" flx="col" ai="center">
        <Box mb="sm" ai="center">
          <SubTitle variant="bold" subTitle="eLinx Embedded Link" />
        </Box>
        <Box ai="center">
          <Box maxwidth="700px" pe="sm">
            <TextField
              name="Link"
              variant="lined"
              height="49px"
              value={eLinx.Link}
              onBlur={() => {}}
              onChange={() => {}}
              width="600px"
              readOnly
            />
          </Box>

          <Button
            id="copy-elinx"
            label="Copy URL"
            noShadow
            onClick={() => {
              void navigator.clipboard.writeText(eLinx.Link);
            }}
          />
        </Box>
        <Box mt="lg" flx="row">
          <Box>
            <Button
              id="view-request-details"
              label="View Request Details"
              color="secondary"
              onClick={() => {
                history.push({
                  pathname: `/elinx-history/details/${eLinx.ELinxRequestID}`,
                  state: {
                    eLinx,
                  },
                });
                setSubNavActiveModule('paylinkHistory');
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PaylinkCreationPage;
